import { useSyncExternalStore } from 'react';

/* Structural breakpoint. Below 768px the shell switches from the desktop
   sidebar layout to a mobile bottom-tab layout. Layout WITHIN surfaces is
   handled by responsive CSS (auto-fit grids), so this hook is only for the
   handful of places where the DOM structure itself must differ. */
const MOBILE_QUERY = '(max-width: 767px)';

function subscribe(onChange: () => void): () => void {
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(MOBILE_QUERY).matches,
    () => false, // SSR / prerender default: desktop
  );
}
